
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/articles/indesign-templates-automation",
      function () {
        return require("private-next-pages/articles/indesign-templates-automation.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/articles/indesign-templates-automation"])
      });
    }
  